import { AlertReferencePanelTab } from '@aloft/toolkit-shared';
import { Flex, Tabs, Typography } from '@aloft/toolkit-sui';

import { useState } from 'react';

import { AlertsContent } from './AlertsContent.tsx';
import { useAlerts } from './hooks/useAlerts.tsx';

const ALERT_TABS: { value: AlertReferencePanelTab; label: string }[] = [
  { value: 'active', label: 'Active' },
  { value: 'explained', label: 'Explained' },
  { value: 'ignored', label: 'Ignored' },
  { value: 'all', label: 'All' },
];

export const AlertsSheet = () => {
  const alerts = useAlerts();
  const [activeTab, setActiveTab] = useState<AlertReferencePanelTab>('active');

  return (
    <Flex flexDirection="column" gap="24px" padding="16px" width="100%">
      <Typography variant="h1">Alerts</Typography>
      <Flex overflowX="auto" overflowY="hidden">
        <Tabs
          variant="secondary"
          tabs={ALERT_TABS}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
      </Flex>
      <AlertsContent alerts={alerts} activeTab={activeTab} setActiveTab={setActiveTab} />
    </Flex>
  );
};
